import React from 'react';
import jsQR from 'jsqr';
import { Redirect } from 'react-router-dom';
import Packet from './Packet';
import ByteUtils from './ByteUtils';

const MAX_DATA = 100;

class FakeQrScanner extends React.Component {
  constructor(props) {
    super(props);
    this.fileInput = React.createRef();
    this.reader = new FileReader();
    this.state = {
      error: null,
      result: null,
      progress: null,
      cursor: 0,
      nextPacket: null,
      nextAck: 0,
      fileHash: 0,
    };
    this.handleSubmit = this.handleSubmit.bind(this);
    this.nextData = this.nextData.bind(this);
    console.log('constructor!');
  }

  componentDidMount() {
    console.log('componentDidMount');
  }
  componentWillUnmount() {
    console.log('componentWillUnmount');
  }

  handleSubmit(e) {
    e.preventDefault();
    const file = this.fileInput.current.files[0];
    console.log('reading file');
    this.reader.onprogress = this.handleProgress.bind(this);
    this.reader.onload = this.handleLoad.bind(this);
    this.reader.onerror = this.handleError.bind(this);
    this.reader.readAsBinaryString(file);
  }

  handleProgress(e) {
    this.setState({ progress: e });
  }

  handleLoad() {
    const nextPacket = Packet.encodeInitialPacket();
    console.log('finished loading file', nextPacket);
    this.setState({
      result: this.reader.result,
      nextPacket: nextPacket,
      fileHash: nextPacket.fileHash,
      nextAck: 0,
    });
  }

  handleError() {
    this.setState({ error: this.reader.error });
  }

  nextData() {
    console.log('fakeQrScanner sending', this.state.nextPacket.toString());
    this.props.handleScan(this.state.nextPacket.toArrayBuffer());
    if (this.state.nextPacket.packetType === Packet.packetTypes.EOF_PACKET) {
      this.setState({
        error: null,
        result: null,
        progress: null,
        cursor: 0,
        nextPacket: null,
        nextAck: 0,
        fileHash: 0,
      });
      return;
    }
    if (this.state.cursor >= this.state.result.length) {
      this.setState((state, props) => ({
        nextPacket: Packet.encodeEofPacket(state.fileHash, state.nextAck + 1),
      }));
    } else {
      this.setState((state, props) => ({
        cursor: state.cursor + MAX_DATA,
        nextPacket: Packet.encodeDataPacket(
          state.fileHash,
          state.nextAck + 1,
          ByteUtils.stringToArrayBuffer(
            state.result.slice(state.cursor, state.cursor + MAX_DATA)
          )
        ),
        nextAck: state.nextAck + 1,
      }));
    }
  }

  render() {
    let maybeFileInput;
    if (!this.state.result) {
      maybeFileInput = (
        <form onSubmit={this.handleSubmit} className='send-form'>
          <label>
            Choose file to fake transfer:
            <input type='file' ref={this.fileInput} multiple />
          </label>
          <br />
          <button type='submit' className='btn btn-primary'>
            Send
          </button>
        </form>
      );
    }
    let maybeAckPacket;
    if (this.state.nextPacket) {
      maybeAckPacket = (
        <button onClick={this.nextData} className='btn btn-primary'>
          Send packet {this.state.nextAck}
        </button>
      );
    }
    // console.log('rendering', this.state);
    return (
      <div>
        {maybeFileInput}
        {maybeAckPacket}
      </div>
    );
  }
}

export default FakeQrScanner;
